var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-spinner',{class:_vm.customClass,style:(_vm.customSizeStyle),attrs:{"type":_vm.spinnerType,"variant":_vm.spinnerVariant,"small":_vm.smallSize,"label":_vm.accessibilityLabel}},[_vm._t("label")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }